import { onRowTableAdd } from '../action/AddRow'
import { onRowTableUpdate } from '../action/EditRow'
import { onRowTableDelete } from '../action/DeleteRow'
import {
  onRowApiAdd,
  onRowApiDelete,
  onRowApiUpdate,
} from '../action/ApiRow'

export const createActionRendererHelper = ({
  isReadOnly,
  propAction,
  showAddAction,
  appendPrintAction,
  createEditRowAction,
  createDeleteRowAction,
  onRowDefaultAction,
  getApiRowProps,
}) => {
  const isSoftDeleteAction = (item = {}) => {
    let method = item.method || ''
    method = method.toLowerCase()

    return (
      item.action === 'updateStatus' ||
      item.statusField ||
      (method && method !== 'delete')
    )
  }

  const renderEditableTableAction = (
    action,
    rowTableAction,
    newEditable,
    option = {},
  ) => {
    const {
      showAddButton = false,
      onRowAdd,
      onRowUpdate,
      onRowDelete,
      onRowDeleteAction,
    } = option
    action.forEach((item) => {
      const { name, isActive } = item
      if (!isActive) return
      switch (name) {
        case 'add':
          if (showAddButton) showAddAction(item)
          return isReadOnly ? null : (newEditable.onRowAdd = onRowAdd(item))
        case 'update':
          return isReadOnly
            ? null
            : (newEditable.onRowUpdate = onRowUpdate(item))
        case 'delete':
          if (isReadOnly) return null
          if (onRowDeleteAction) {
            let deleteAction = onRowDeleteAction(item)
            if (deleteAction) {
              rowTableAction.push(deleteAction)
              return
            }
          }
          return (newEditable.onRowDelete = onRowDelete(item))
        case 'print':
          rowTableAction = appendPrintAction(item, rowTableAction)
          return
        default:
          return
      }
    })
    return { rowTableAction, newEditable }
  }

  const renderApiAction = (action, column, rowTableAction, newEditable) => {
    if (column.editable) {
      let editableAction = renderEditableTableAction(
        action,
        rowTableAction,
        newEditable,
        {
          showAddButton: true,
          onRowAdd: (item) => (newData) =>
            onRowApiAdd(newData, item, getApiRowProps()),
          onRowUpdate: (item) => (newData, oldData) =>
            onRowApiUpdate(newData, oldData, item, getApiRowProps()),
          onRowDelete: (item) => (oldData) =>
            onRowApiDelete(oldData, item, getApiRowProps()),
          onRowDeleteAction: (item) =>
            isSoftDeleteAction(item) ? createDeleteRowAction(item) : null,
        },
      )
      rowTableAction = editableAction.rowTableAction
      newEditable = editableAction.newEditable
    } else {
      action.forEach((item) => {
        const { name, isActive } = item
        if (!isActive) return
        if (name === 'add') {
          if (!isReadOnly)
            showAddAction(item)
        } else if (name === 'update') {
          if (!isReadOnly)
            rowTableAction.push(createEditRowAction(item))
        } else if (name === 'delete') {
          if (!isReadOnly) {
            if (isSoftDeleteAction(item)) {
              rowTableAction.push(createDeleteRowAction(item))
            } else {
              newEditable.onRowDelete = (oldData) =>
                onRowDefaultAction(item, oldData)
            }
          }
        } else if (name === 'print') {
          rowTableAction = appendPrintAction(item, rowTableAction)
        }
      })
    }
    return { rowTableAction, newEditable }
  }

  const renderDefaultAction = (action, rowData, rowTableAction, newEditable) => {
    action.forEach((item) => {
      const { name, isActive } = item
      if (!isActive) return
      if (name === 'add') {
        if (!isReadOnly)
          showAddAction(item)
      } else if (name === 'update') {
        if (!isReadOnly)
          rowTableAction.push(createEditRowAction(item))
      } else if (name === 'delete') {
        if (!isReadOnly)
          newEditable.onRowDelete = (oldData) =>
            onRowDefaultAction(item, rowData)
      } else if (name === 'print') {
        rowTableAction = appendPrintAction(item, rowTableAction, {
          prepend: true,
        })
      }
    })
    return { rowTableAction, newEditable }
  }

  const renderArrayAction = (action, column, rowTableAction, newEditable) => {
    if (column.editable) {
      let editableAction = renderEditableTableAction(
        action,
        rowTableAction,
        newEditable,
        {
          onRowAdd: () => (newData) =>
            onRowTableAdd(newData, propAction),
          onRowUpdate: () => (newData, oldData) =>
            onRowTableUpdate(newData, oldData, propAction),
          onRowDelete: (item) => (oldData) =>
            onRowTableDelete(oldData, item, propAction),
        },
      )
      rowTableAction = editableAction.rowTableAction
      newEditable = editableAction.newEditable
    } else {
      action.forEach((item) => {
        const { name, isActive } = item
        if (!isActive) return
        if (name === 'add') {
          if (!isReadOnly)
            showAddAction(item)
        } else if (name === 'update') {
          if (!isReadOnly)
            rowTableAction.push(createEditRowAction(item))
        } else if (name === 'delete') {
          return isReadOnly
            ? null
            : (newEditable.onRowDelete = (oldData) =>
                onRowTableDelete(oldData, item, propAction))
        } else if (name === 'print') {
          rowTableAction = appendPrintAction(item, rowTableAction)
        }
      })
    }
    return { rowTableAction, newEditable }
  }

  const renderActionBySaveType = (column, rowData) => {
    let action = column?.action || []
    let rowTableAction = []
    let newEditable = {}
    if (column.saveType === 'array') {
      let arrayAction = renderArrayAction(
        action,
        column,
        rowTableAction,
        newEditable,
      )
      rowTableAction = arrayAction.rowTableAction
      newEditable = arrayAction.newEditable
    } else if (column.saveType === 'api') {
      let apiAction = renderApiAction(
        action,
        column,
        rowTableAction,
        newEditable,
      )
      rowTableAction = apiAction.rowTableAction
      newEditable = apiAction.newEditable
    } else {
      let defaultAction = renderDefaultAction(
        action,
        rowData,
        rowTableAction,
        newEditable,
      )
      rowTableAction = defaultAction.rowTableAction
      newEditable = defaultAction.newEditable
    }
    return { rowTableAction, newEditable }
  }

  return {
    renderEditableTableAction,
    renderApiAction,
    renderDefaultAction,
    renderArrayAction,
    renderActionBySaveType,
  }
}
